import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FreeLayout } from 'Layouts';
import { registerSecondScreen } from 'State/SecondScreen/SecondScreenActions';
import './Confirmation.css';

const getScreenName = (isChangePlan, screens) => {
  const { confirmationScreen, upgradeConfirmationScreen = '' } = screens;
  if (isChangePlan) {
    return upgradeConfirmationScreen;
  }
  return confirmationScreen;
};

export class ConfirmationComponent extends Component {
  componentDidMount() {
    const { isDeviceActivation, registerSecondScreen } = this.props;

    if (isDeviceActivation) {
      registerSecondScreen();
    }
  }

  render() {
    const { isChangePlan, screens } = this.props;
    const screenName = getScreenName(isChangePlan, screens);
    return <FreeLayout className="congrats" screenName={screenName} />;
  }
}

const mapStateToProps = ({
  appConfig: { screens },
  purchaseMode: { isChangePlan },
  secondScreen: { isDeviceActivation },
}) => ({
  screens,
  isChangePlan,
  isDeviceActivation,
});

const mapDispatchToProps = {
  registerSecondScreen,
};

export const Confirmation = connect(mapStateToProps, mapDispatchToProps)(ConfirmationComponent);
